import styled from 'styled-components';
import { venueList, Venue, COUNTRY_ISO } from '../lib/venues';
import { H2 } from '../components/ui';

const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius};
  padding: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  .flag {
    width: 34px;
    height: 24px;
    border-radius: 4px;
    object-fit: cover;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.border};
    flex: 0 0 auto;
  }
  .name { font-weight: 700; }
  small { color: ${({ theme }) => theme.colors.textMuted}; }
  .cap {
    margin-left: auto;
    text-align: right;
    font-size: 0.77rem;
    color: ${({ theme }) => theme.colors.textMuted};
    white-space: nowrap;
  }
`;

const COUNTRIES: Venue['country'][] = ['USA', 'México', 'Canadá'];

export function Venues() {
  const all = venueList();
  return (
    <>
      {COUNTRIES.map((country) => {
        const vs = all.filter((v) => v.country === country);
        return (
          <section key={country}>
            <H2>
              {vs[0]?.flag} {country} · {vs.length} sedes
            </H2>
            {vs.map((v) => (
              <Card key={v.ground}>
                <img
                  className="flag"
                  src={`https://flagcdn.com/w160/${COUNTRY_ISO[v.country]}.png`}
                  alt={v.country}
                  loading="lazy"
                />
                <span>
                  <div className="name">{v.stadium}</div>
                  <small>{v.city}</small>
                </span>
                <span className="cap">
                  ~{v.capacity.toLocaleString('es-AR')}
                  <br />
                  espectadores
                </span>
              </Card>
            ))}
          </section>
        );
      })}
    </>
  );
}
